<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <div class="container-box">
        <div class="text-center">
        <img width="100px" height="100px" src="../assets/img/icon/userprofile.svg" />
        <br />
        <h3 class="title mt-4">Hello Aliff!</h3>
        <br />
        <h4 class="sub-title-header">
           Nice photo!
        </h4>
      </div>
       
      </div>
    </CContainer>
    <div class="bottom-center">
      <CButton color="info" class="custom-btn-login-active mt-5"  @click="GoSuccessRegister()"> Next</CButton>
      <br />
        <label class="mt-3 custom-label-note">
       <span class="text-inline">Change Image</span> </label>
    </div>
    <div class="header-top">Upload Image</div>
    <div class="header-left">
      <img src="../assets/img/icon/VectorLeft.svg" />
    </div>
    <div style="clear: both"></div>
  </div>
</template>


<script>
export default {
  name: "Login",
  e1: "#app",
  data: function () {
    return {
    };
  },
  async mounted() {},
  methods: {
    GoBack() {
     this.$router.back();
    },
     GoSuccessRegister() {
    this.$router.push("SuccessRegister");
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
body {
  font-family: "Montserrat", sans-serif;
}
.container-box {
  max-width: 335px;
  margin: 0 auto;
}
</style>